export interface EditorPlaceholder {
  label: string;
  placeholder: string;
}
